import { render, staticRenderFns } from "./MessageDialog.vue?vue&type=template&id=0b57b44f&scoped=true"
import script from "./MessageDialog.vue?vue&type=script&lang=js"
export * from "./MessageDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageDialog.vue?vue&type=style&index=0&id=0b57b44f&prod&lang=css"
import style1 from "./MessageDialog.vue?vue&type=style&index=1&id=0b57b44f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b57b44f",
  null
  
)

export default component.exports